"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const sortCookieGroups = groups => {
  var _groups$filter, _groups$filter2, _groups$filter3, _cookiesRequired$conc;
  let cookiesRequired = groups === null || groups === void 0 || (_groups$filter = groups.filter(item => item.groupType === 0)) === null || _groups$filter === void 0 ? void 0 : _groups$filter.map(group => {
    var _group$items;
    let items = group === null || group === void 0 || (_group$items = group.items) === null || _group$items === void 0 ? void 0 : _group$items.map(item => {
      return {
        ...item,
        selected: true
      };
    });
    return {
      ...group,
      items
    };
  });
  let cookiesFunctional = groups === null || groups === void 0 || (_groups$filter2 = groups.filter(item => item.groupType === 4)) === null || _groups$filter2 === void 0 ? void 0 : _groups$filter2.map(group => {
    var _group$items2;
    let items = group === null || group === void 0 || (_group$items2 = group.items) === null || _group$items2 === void 0 ? void 0 : _group$items2.map(item => {
      return {
        ...item,
        selected: false
      };
    });
    return {
      ...group,
      items
    };
  });
  let cookiesExceptFunctionalOrRequired = groups === null || groups === void 0 || (_groups$filter3 = groups.filter(item => item.groupType !== 0 && item.groupType !== 4)) === null || _groups$filter3 === void 0 ? void 0 : _groups$filter3.map(group => {
    var _group$items3;
    let items = group === null || group === void 0 || (_group$items3 = group.items) === null || _group$items3 === void 0 ? void 0 : _group$items3.map(item => {
      return {
        ...item,
        selected: false
      };
    });
    return {
      ...group,
      items
    };
  });
  return (_cookiesRequired$conc = cookiesRequired.concat(cookiesFunctional).concat(cookiesExceptFunctionalOrRequired)) !== null && _cookiesRequired$conc !== void 0 ? _cookiesRequired$conc : [];
};
var _default = exports.default = sortCookieGroups;